import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import route constants
import { ROUTES } from './utils/routes';

// Import Navbar and Footer (used on all pages)
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';

// Import Page Components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CareersPage from './pages/CareersPage';
import TechnologyEcosystemPage from './pages/TechnologyEcosystemPage';
import WhyMSTechnologiesPage from './pages/WhyMSTechnologiesPage';
import LeadershipPage from './pages/LeadershipPage';
import IndustriesPage from './pages/IndustriesPage';
import InsightsPage from './pages/InsightsPage';
import InsightsDetailPage from './pages/InsightsDetailPage';
import SolutionsPage from './pages/SolutionsPage';
import SAPTransformationPage from './pages/SAPTransformationPage';
import AIDatabricsPage from './pages/AIDatabricsPage';
import BlockchainWeb3Page from './pages/BlockchainWeb3Page';
import NotFoundPage from './pages/NotFoundPage';

/**
 * Main App Component with React Router Configuration
 * 
 * This component handles:
 * - Route rendering based on URL
 * - AOS animation initialization
 * - Navbar and Footer layout
 */
function App() {
  // Initialize AOS animations on component mount
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <div className="App">
      {/* Navbar is displayed on all pages */}
      <Navbar />

      {/* Route-based page rendering */}
      <Routes>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.ABOUT} element={<AboutPage />} />
        <Route path={ROUTES.CONTACT} element={<ContactPage />} />
        <Route path={ROUTES.CAREERS} element={<CareersPage />} />
        <Route path={ROUTES.TECHNOLOGY_ECOSYSTEM} element={<TechnologyEcosystemPage />} />
        <Route path={ROUTES.WHY_MS_TECHNOLOGIES} element={<WhyMSTechnologiesPage />} />
        <Route path={ROUTES.LEADERSHIP} element={<LeadershipPage />} />
        <Route path={ROUTES.INDUSTRIES} element={<IndustriesPage />} />
        <Route path={ROUTES.INSIGHTS} element={<InsightsPage />} />
        <Route path={ROUTES.INSIGHTS_DETAIL} element={<InsightsDetailPage />} />
        <Route path={ROUTES.SOLUTIONS} element={<SolutionsPage />} />
        <Route path={ROUTES.SAP_SOLUTIONS} element={<SAPTransformationPage />} />
        <Route path={ROUTES.AI_SOLUTIONS} element={<AIDatabricsPage />} />
        <Route path={ROUTES.BLOCKCHAIN_SOLUTIONS} element={<BlockchainWeb3Page />} />

        {/* Redirect undefined routes to 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Footer is displayed on all pages */}
      <Footer />
    </div>
  );
}

export default App;
